// extracted by mini-css-extract-plugin
export default {"memesList":"MemesPage_memesList__yN1jf","ytVideo":"MemesPage_ytVideo__Da1Xq","memesPage":"MemesPage_memesPage__+dZ78"};